(function (angular) {
    'use strict';

    angular.module('Common')

        /**
         *
         */
        .factory("utilService", ['portalConfig', function (config) {
            var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
            var httpUrlRegex = /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
            var fieldTypes = [{
                val: "string",
                label: "text"
            }, {
                val: "number",
                label: "number"
            }, {
                val: "date",
                label: "date"
            }, {
                val: "link",
                label: "url"
            }, {
                val: "image",
                label: "image"
            }, {
                val: "boolean",
                label: "true/false"
            }];

            var fieldMultipleTypes = fieldTypes.reduce(function (result, item, index, array) {
                result[item.val] = item.label;
                if (!result[item.label]) {
                    result[item.label] = item.val;
                }
                return result;
            }, {});



            // http://, https://, ftp://
            var urlPattern = /(^| )(https?|ftp?)(\S+)/gim;

            // www. sans http:// or https://
            var pseudoUrlPattern = /(^| )(www)(\S+)/gim;

            // Email addresses
            var emailAddressPattern = /[\w.]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,6})+/gim;

            var fac = {
                /**
                 *
                 */
                uuid: function () {
                    var d = new Date().getTime();
                    if (window.performance && typeof window.performance.now === "function") {
                        d += performance.now(); //use high-precision timer if available
                    }
                    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                        var r = (d + Math.random() * 16) % 16 | 0;
                        d = Math.floor(d / 16);
                        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                    });
                    return uuid;
                },
                buildSmsUrl: function (relativePath) {
                    var environment = config.environmentPrefix == "staging" ? "https://apps-cpaas.staging.dotdigital.com" :
                        config.environmentPrefix == "production" ? "https://apps-cpaas.dotdigital.com" :
                        "https://debug-apps-cpaas.dotdigital.internal"
                    return environment + relativePath;
                },
                buildCpaasAdminUrl: function (relativePath) {
                    var environment = config.environmentPrefix == "staging" ? "https://stage-adminportal.comapi.com" :
                        config.environmentPrefix == "production" ? "https://adminportal.comapi.com" :
                        "https://local-docker-adminportal.comapi.com:8801"
                    return environment + relativePath;
                },
                formatValidationErrors: function (validationErrors) {
                    if (validationErrors && validationErrors.length > 0) {
                        var message = "<div class='validationErrors'><b>Validation Failures:</b><br/><ul>"

                        validationErrors.forEach(function (error) {
                            message += ("<li>" + error.paramName + ": " + error.message + "</li>");
                        });

                        message += "</ul></div>";
                        return message;
                    }
                },
                translateFieldType: function (type) {
                    return fieldMultipleTypes[type];
                },
                getFieldTypes: function () {
                    return fieldTypes;
                },
                msgCounter: function (message) {
                    // gsm chars = "@£$¥èéùìòÇØøÅå_ÆæßÉ !\"#¤%&'¡ÄÖÑÜ§¿()*+,-./0123456789:;<=>?ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzäöñüà"
                    // extended gsm chars = "[^\]~|€{}"
                    //var GSMRegEx = new RegExp("^[A-Za-z0-9 \\r\\n@£$¥èéùìòÇØøÅå\u0394_\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039EÆæßÉ!\"#$%&'()*+,\\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}\\\\\\[~\\]|\u20AC]*$");
                    var gsmChars = "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
                    var gsmExtChars = "^{}\\[~]|€";

                    var bIsUnicode = false;
                    var msgCount = 0;
                    var charCount = 0;
                    var GSMCount = 0;
                    var GSMExtCount = 0;

                    for (var i = 0; (!bIsUnicode && (i < message.length)); i++) {
                        if (gsmChars.indexOf(message.charAt(i)) > -1) {
                            GSMCount++;
                        } else if (gsmExtChars.indexOf(message.charAt(i)) > -1) {
                            GSMExtCount++;
                        } else {
                            bIsUnicode = true;
                        }
                    }

                    if (bIsUnicode) {
                        charCount = message.length;
                    } else {
                        charCount = GSMCount + (2 * GSMExtCount);
                    }

                    msgCount = charCount;

                    if (bIsUnicode) {
                        if (msgCount <= 70 && msgCount > 0) {
                            msgCount = 1;
                        } else {
                            msgCount += (67 - 1);
                            msgCount -= (msgCount % 67);
                            msgCount /= 67;
                        }
                    } else {
                        if (msgCount <= 160 && msgCount > 0) {
                            msgCount = 1;
                        } else {
                            msgCount += (153 - 1);
                            msgCount -= (msgCount % 153);
                            msgCount /= 153;
                        }
                    }

                    var ret = {
                        bIsUnicode: bIsUnicode,
                        charCount: charCount,
                        msgCount: msgCount
                    };

                    return ret;
                },
                /**
                 * Shared function used by form directives t determine whether to display validation errors or not
                 */
                formFieldHasError: function (showInvalid, form, name) {
                    if (form && form[name]) {
                        if (showInvalid === true) {
                            return form[name].$invalid;
                        } else if (form[name].$untouched) {
                            return false;
                        } else {
                            return form[name].$untouched ? false : form[name].$invalid;
                        }
                    } else {
                        return false;
                    }
                },

                /**
                 * https://stackoverflow.com/questions/286141/remove-blank-attributes-from-an-object-in-javascript
                 * @param {*} obj 
                 */
                removeEmpty: function (obj) {
                    Object.keys(obj).forEach(function (key) {
                        if (obj[key] && typeof obj[key] === 'object') {
                            fac.removeEmpty(obj[key]);
                        }
                        else if (obj[key] == null) {
                            delete obj[key];
                        }
                    });
                },
                /**
                 * It should convert all links and emails into clickable ones
                 * @param {string} text 
                 */
                linkify: function(text){
                    if(typeof text !== "string"){
                        return text;
                    };
                    
                    return text.replace(urlPattern, '$1<a target="_blank" href="$2$3">$2$3</a>')
                        .replace(pseudoUrlPattern, '$1<a target="_blank" href="http://$2$3">$2$3</a>')
                        .replace(emailAddressPattern, '<a target="_blank" href="mailto:$&">$&</a>');
                    
                },
                validateEmail: function(email){
                    return email ? emailRegex.test(email) : true;
                },
                validateUrl: function(url, httpRequired){
                    var regex = httpRequired ? httpUrlRegex : urlRegex;
                    return url ? regex.test(url) : true;
                },
                getEmailValidationRegex: function(){
                    return emailRegex;
                },
                getUrlValidationRegex: function(){
                    return urlRegex;
                }
            };

            return fac;
        }]);



})(window.angular);
